import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';

const tutorInvoicesOpenedTemplate = ({ classes, notificationData }) => {
  const {
    dryRun,
    triggeredBy,
    runAt,
    invoices = [],
  } = notificationData;
  const runTime = runAt ? dayjs(runAt).format('DD MMMM YYYY HH:mm') : null;
  const action = dryRun ? 'would be opened' : 'were opened';
  const invoiceCount = invoices.length;

  return (
    <>
      <Typography variant="body1" className={classes.author} component="div">
        <strong>Path Education</strong>
      </Typography>
      <Typography variant="body1" className={classes.message} component="div">
        {invoiceCount} tutor draft invoice{invoiceCount === 1 ? '' : 's'} {action}
        {triggeredBy?.name && <> by <strong>{triggeredBy.name}</strong></>}
        {runTime && <> on <strong>{runTime}</strong></>}.
      </Typography>
      {invoices.map((invoice) => (
        <Typography
          key={invoice.invoiceId}
          variant="body2"
          className={classes.message}
          component="div"
        >
          <strong>{invoice.userName}</strong> ({invoice.userId}) invoice{' '}
          <strong>{invoice.invoiceId}</strong>
        </Typography>
      ))}
    </>
  );
};

export default tutorInvoicesOpenedTemplate;
